const defaultLocations: Record<string, string> = {
  au: 'All Australia',
  nz: 'All New Zealand',
};

export const mapLocationInput = ({
  country,
  where,
}: {
  where?: string;
  country?: string;
}) => {
  const isDefaultLocation =
    country && defaultLocations[country.toLowerCase()] === where;

  if (!where || isDefaultLocation) {
    return undefined;
  }

  return where;
};
